import React, { forwardRef, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { assignRef } from '../../../utils/helpers.mjs';
import { useIsomorphicEffect, createPortalNode } from './Portal.utils.mjs';

const Portal = forwardRef((props, ref) => {
  const { children, target, ...rest } = props;
  const [mounted, setMounted] = useState(false);
  const nodeRef = useRef(null);
  useIsomorphicEffect(() => {
    setMounted(true);
    nodeRef.current = !target ? createPortalNode(rest) : typeof target === "string" ? document.querySelector(target) : target;
    assignRef(ref, nodeRef.current);
    if (!target && nodeRef.current) {
      document.body.appendChild(nodeRef.current);
    }
    return () => {
      if (!target && nodeRef.current) {
        document.body.removeChild(nodeRef.current);
      }
    };
  }, [target]);
  if (!mounted || !nodeRef.current) {
    return null;
  }
  return createPortal(/* @__PURE__ */ React.createElement(React.Fragment, null, children), nodeRef.current);
});

export { Portal };
